import { config } from '../../config';

/**
 * Client ids referenced by a house document. The field is read in a few shapes
 * so the check holds whether the house carries `client`, `clientId` or a
 * `clients` list, and whether each entry is an id or a populated object.
 */
export const houseClientIds = (house) => {
  const raw = [
    house?.client,
    house?.clientId,
    ...(Array.isArray(house?.clients) ? house.clients : []),
  ];

  return raw
    .map((entry) => (typeof entry === 'string' ? entry : entry?._id || entry?.clientId))
    .filter(Boolean)
    .map(String);
};

/**
 * The Device Moved page is only offered while the dashboard's selected house
 * belongs to one of the allowlisted clients.
 */
export const canAccessDeviceMove = (house) =>
  houseClientIds(house).some((id) => config.deviceMoveClients.includes(id));
